import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityMessage } from "../../entity/EntityMessage";

export class DtoMessagesPutReq extends EntityMessage {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_message_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
